<template>
  <h1>Projects</h1>
  <!-- Cards -->
  <div class="carousel-item">
    <img src="@/assets/projects/FIrstPortfolio.jpg" alt="..." />
    <div class="carousel-caption d-none d-md-block">
      <h5>...</h5>
      <p>...</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
